import styled, { keyframes } from "styled-components";
import { fadeInLeft, fadeInRight } from "react-animations";
import { primaryColor, bodyColor } from "../../config/constants";

// Keyframes
const fadeInLeftAnimation = keyframes`${fadeInLeft}`;
const fadeInRightAnimation = keyframes`${fadeInRight}`;
// Styles
export const SelectLng = styled.div`
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  animation: 0.3s ${fadeInRightAnimation};
`;
export const LngAndSelector = styled.div`
  display: flex;
`;
export const ChangeLngButton = styled.button`
  font-size: ${({ fontSize }) => fontSize && fontSize};
  font-weight: bold;
  color: ${({ active }) => (active ? "#808080" : `${primaryColor}`)};
  background: transparent;
  outline: none;
  border: none;
  cursor: pointer;
`;
export const LngSeparator = styled.div`
  margin: 0 5px;
  width: 2px;
  height: 16px;
  background: ${bodyColor};
`;
export const ShowLanguages = styled.button`
  margin-left: 12px;
  height: 12px;
  background: transparent;
  outline: none;
  border: none;
  cursor: pointer;
`;
export const CurrentLngButton = styled.button`
  padding: 0 2px;
  width: 40px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  outline: none;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  animation: 0.3s ${fadeInLeftAnimation};
`;
export const CurrentLngText = styled.p`
  font-size: 14px;
  font-weight: bold;
  color: #808080;
`;
export const ArrowImg = styled.img`
  height: 12px;
`;
